import * as React from "react";
import * as ReactDOM from "react-dom";
import "./index.less";
import { Provider } from "react-redux";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { App } from "./components/App";
import * as serviceWorker from "./serviceWorker";

import { store } from "./store";

ReactDOM.render(
  <GoogleReCaptchaProvider reCaptchaKey="6Lfnl7oZAAAAALkEeykuLCuAOlsphE14VBGiZj_9">
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </GoogleReCaptchaProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
